<template>
    <div class="container">
        <div class="incontainer">
            <div class="movie">
            <div class="movcontainer">
                <div class="movies">
                    <div class="movies-name">
                        <ul>
                            <li :class="{ active : selectedSongs.url == sound.url}"  v-for="(sound, index) in videoData" :key="index" @click="openSound(index)">
                               <a> {{ sound.title }}</a>
                            </li>
                        </ul>
                    </div>
                    <div class="movies-player" >
                        <div class="movies-player-video" v-if="selectedSongs">
                            <div class="movies-player-video-title">
                                <h4 >{{ selectedSongs.title }}</h4>
                            </div>
                            
                            <iframe  allowfullscreen  frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" class="iframe" :src="'https://www.youtube.com/embed/'+this.selectedSongs.url" controls></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>
      </template>
      
      <script>
    
      export default {
        name:'albumAskDelidir',
        data() {
          return {
            videoData: [
              {
                title: 'Yar Senin Derdin Ne',
                url: 'LwadA6nrC-M'
              },
              {
                title: 'Alnının Yazısı',
                url: 'UTL5JGSG3KY'
              },
              {
                title: 'Delilerin Delisi',
                url: 'oL3ijMlivUg'
              },
              {
                title: 'Ask Yandın Yeridir',
                url: 'uEjmLDQBqmM'
              },
              {
                title: 'Sıkıldım',
                url: 'ZwBZi8faYJA'
              },
              {
                title: 'İki Sevgili',
                url: '0rDVmxMtadw'
              },
              {
                title: 'Doyamadım Sana',
                url: 'yzuPhqMrxJc'
              },
              {
                title: 'Mendil',
                url: 'TTFl8JmwEIc'
              },
              {
                title: 'Saklan Gecelere',
                url: 'o4Ak5Lx3QR8'
              },
              {
                title: 'Gitme',
                url: '1Db2VHNoPek'
              },
              // diğer videolar
            ],
            selectedSongs: {
                title: 'Yar Senin Derdin Ne',
                url: 'LwadA6nrC-M'
          }
            
          };
        },
        methods:{
            openSound(index) {
                this.selectedSongs = this.videoData[index];
                console.log(this.selectedSongs.url)
            }
        }
      };
    
    
      </script>
      
      <style scoped>
    
    
      </style>
    